import React from 'react';
import { Field } from 'react-final-form';
import SwitchboxInput from '../../../components/forms/SwitchboxInput';
import TextInput from '../../../components/forms/TextInput';
import { capitalize } from '../../../libraries/utils';
import SelectInput from '../../../components/forms/SelectInput';


export default class ItemSettings extends React.Component {
  constructor(props) {
    super(props);
    }

    render() {
      const { setting, view, editing, options=[] } = this.props;
      const optionSelect= [{label: "Selecciona una opcion", value: ""}];
      
      if(setting?.optionsValue){
        // debugger
        setting?.optionsValue?.split(",").forEach((option)=>{
          optionSelect.push({label: capitalize(option), value: option})
        });
      }else{
        options?.forEach((option)=>optionSelect.push(option));
      }      
      if(setting?.data_type === "select"){
        return(
          <div className="w-full px-3 md:mb-0 font-bold">
            <Field
              labelClassName="mt-3"
              name={setting.code}
              component={SelectInput}
              options={optionSelect}
              label={setting.name}
              readOnly={view && !editing}
              validate={this.props.validate ?? (()=>{})}
            />
            <span className="italic font-light">
              {setting.details}
            </span>
          </div>
      )
      }
      if (setting?.data_type === "text") {
       return(<div className="w-full md:w-fit px-3 md:mb-0 font-bold">
          <Field
            labelClassName="mt-3"
            name={setting.code}
            component={TextInput}
            label={setting.name}
            readOnly={view && !editing}
          />
          <div className="w-full px-3 mb-3 md:mb-0 italic">
            <span>{setting.details}</span>
          </div>
        </div>)
      }
      if (setting?.data_type === "switch") {
        return (
          <div className="w-full px-3 md:mb-0 font-bold">
            <Field
              labelClassName="mt-3"
              name={setting.code}
              component={SwitchboxInput}
              label={setting.name}
              readOnly={view && !editing}
            />
            <span className="italic font-normal">
            <span>{setting.details}</span>
            </span>
          </div>
        )
      }
      return <></>
    }
  }